import { render } from "./PartnerCategoryView.vue?vue&type=template&id=6318b011"
import script from "./PartnerCategoryView.vue?vue&type=script&lang=js"
export * from "./PartnerCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__